$(document).ready(function () {
  setCssVariables();
  setTimeout(setCssVariables, 100);
});

$(window).resize(function () {
  clearTimeout(cssVariablesResizer);
  cssVariablesResizer = setTimeout(setCssVariables, 100);
});

function setCssVariables() {
  document.documentElement.style.setProperty('--page-header--height', ($('.layout-header').outerHeight() + "px"));
  document.documentElement.style.setProperty('--wrapper-space--width', ($('.wrapper').innerWidth() - $('.container--default').width()) / 2 + "px");
}
